import { useScroll } from "framer-motion";
import { handleFocus, handleBlur } from "../../../functions/utilities";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBan, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from "@mui/material";
import { adresPro2, findMieszkanieId } from "../../../functions/ulice";

const WodaGrupoweTBody = props => {

    const { wybranaWspolnota, mieszkancy, ulice, lokale, users_w, grupy, odczyty, planowaneZuzycie, 
        udzialyKontaAkt, czyWybranaWspolnota, tablica, setTablica, uzupelnione } = props;                   

    const handleCheck = e => {
        setTablica( tablica?.map( obj => 
            obj.id == e.target.id 
                ? {...obj, czy_wybrany: !obj.czy_wybrany}
                : obj
        ))
    }
    
    const handleZp = e => e.target.value >= 0 && setTablica( tablica?.map( obj => obj.id == e.target.id ? {...obj, zimna_poczatek: e.target.value, zimna_zuzycie: parseFloat(obj.zimna_koniec) - parseFloat(e.target.value)} : obj ));
    const handleZk = e => e.target.value >= 0 && setTablica( tablica?.map( obj => obj.id == e.target.id ? {...obj, zimna_koniec: e.target.value,   zimna_zuzycie: parseFloat(e.target.value) - parseFloat(obj.zimna_poczatek)} : obj ));
    const handleCp = e => e.target.value >= 0 && setTablica( tablica?.map( obj => obj.id == e.target.id ? {...obj, ciepla_poczatek: e.target.value, ciepla_zuzycie: parseFloat(obj.ciepla_koniec) - parseFloat(e.target.value)} : obj ));
    const handleCk = e => e.target.value >= 0 && setTablica( tablica?.map( obj => obj.id == e.target.id ? {...obj, ciepla_koniec: e.target.value, ciepla_zuzycie: parseFloat(e.target.value) - parseFloat(obj.ciepla_poczatek)} : obj ));
    
    const [rowIndex, setRowIndex] = useState(null);

    const handleF = (e, i) => {
        setRowIndex(i);
        handleFocus(e);
    }

    const handleB = e => {
        setRowIndex(null);
        handleBlur(e);
    }

    const [zestaw, setZestaw] = useState(undefined);

    useEffect( () => {
        const temp = udzialyKontaAkt?.map( udzial => {
            const mieszkaniec = mieszkancy?.find( m => m?.id_user == udzial?.id_user); 
            const mieszkaniecId = mieszkaniec ? `${mieszkaniec?.imie_nazwisko} (${mieszkaniec?.id_user})` : "";
            const czyUzupelniony = uzupelnione?.find( u => u?.id_user == udzial?.id_user && u?.grupa_numer == udzial?.grupa_numer ) || false;
            const grupy_u = grupy?.filter( g => g?.id_user == udzial?.id_user && g?.grupa_numer == udzial?.grupa_numer );
            const adres = adresPro2(udzial, lokale, ulice, grupy_u);
            const lokalId = findMieszkanieId(udzial, grupy_u, lokale);
            const lokal = lokale?.find( u => u?.id == lokalId);

            const odczyt = tablica?.find( t => t?.id_user == udzial?.id_user && t?.grupa_numer == udzial?.grupa_numer );

            return ({
                ...udzial,
                mieszkaniecId,
                adres,
                ulicaId: lokal?.ulica,
                lokalNr: lokal?.numer,
                odczyt,
                czyUzupelniony
            })
        })
        
        const posortowane = temp.sort((a, b) => {
            const idA = Number(a.ulicaId);
            const idB = Number(b.ulicaId);

            if (idA !== idB) {
                return idA - idB;
            }

            // Jeśli lokalId są równe, sortuj po lokalNr
            const nrA = Number(a.lokalNr);
            const nrB = Number(b.lokalNr);

            return nrA - nrB;
        });
        
        setZestaw(posortowane);
    },[udzialyKontaAkt, mieszkancy, tablica, uzupelnione, wybranaWspolnota]);
    
    const tab = zestaw?.map( (udzial, i) => {

        const {odczyt} = udzial;
        const active = rowIndex === i ? "active" : "";
        const disabled = !odczyt?.czy_wybrany ? "disabled-text" : "";
        
        let svg, hint;

        if (disabled)
            svg = faBan;
        else if (udzial.czyUzupelniony)
            svg = faPen;
        else 
            svg = faPlus;

        return (
            <tr 
                key={i}
                className={ `${active} ${disabled}` }
            >
                <td className={`imiona`}>
                    <span>
                        {udzial?.mieszkaniecId}
                    </span>
                </td>
                <td className={`imiona`}>
                    <span>
                        {udzial?.adres}
                    </span> 
                </td>
                <td>
                    <input 
                        type="checkbox"
                        checked={odczyt?.czy_wybrany}
                        id={odczyt?.id}
                        onChange={handleCheck}
                        onFocus={()=>setRowIndex(i)}
                        onBlur={()=>setRowIndex(null)} 
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.zimna_poczatek}
                        id={odczyt?.id}
                        onChange={handleZp} 
                        onFocus={(e)=>handleF(e, i)}
                        onBlur={(e)=>handleB(e)} 
                        disabled={!odczyt?.czy_wybrany}
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.zimna_koniec}
                        id={odczyt?.id}
                        onChange={handleZk} 
                        onFocus={(e)=>handleF(e, i)}
                        onBlur={(e)=>handleB(e)}
                        disabled={!odczyt?.czy_wybrany}
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.zimna_koniec - odczyt?.zimna_poczatek}
                        disabled
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.ciepla_poczatek}
                        id={odczyt?.id}
                        onChange={handleCp}
                        onFocus={(e)=>handleF(e, i)}
                        onBlur={(e)=>handleB(e)}
                        disabled={!odczyt?.czy_wybrany}
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.ciepla_koniec}
                        id={odczyt?.id}
                        onChange={handleCk}
                        onFocus={(e)=>handleF(e, i)}
                        onBlur={(e)=>handleB(e)}
                        disabled={!odczyt?.czy_wybrany}
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={odczyt?.ciepla_koniec - odczyt?.ciepla_poczatek}
                        disabled
                    />
                </td>
                <td>
                    <input
                        type="number"
                        value={(odczyt?.zimna_koniec - odczyt?.zimna_poczatek) + (odczyt?.ciepla_koniec - odczyt?.ciepla_poczatek)}
                        disabled
                    />
                </td>
                <td>                        
                    <Tooltip
                        title={hint}
                        placement='top'
                    >
                        <FontAwesomeIcon 
                            icon={svg} 
                        />
                    </Tooltip>
                </td>
            </tr>
        )
    })

    return (
        <tbody>
            {tab}
        </tbody>
    )
}

export default WodaGrupoweTBody;